import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { loadHomePageCategories } from '../actions';

class HomeCategories extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadHomePageCategories();
  }

  redirectUser = (categoryLpUrl) => {
    this.props.push(categoryLpUrl);
  }

  render() {
    if (this.props.homePageCategories.isLoading === true) {
      return <span />;
    }
    let homePageCategories = this.props.homePageCategories;

    let imgFilters = <div><img src="images/categories/desktop/shim_categories.gif" alt="" className="desktop home-categoriesItemImageFilter" /><img src="images/categories/mobile/shim_categories.gif" alt="" className="mobile home-categoriesItemImageFilter" /></div>;

    let categoryList = this.props.homePageCategories.homeCategories.map((category, idx) => {

      return <li onClick={this.redirectUser.bind(this, `/browse/${category.slug}`)} className="home-categoriesItem">
      { imgFilters }
      <img src={`images/categories/desktop/${category.slug}.jpg`}  className="desktop home-categoriesItemImage" />
      <img src={`images/categories/mobile/${category.slug}.jpg`} alt="" className="mobile home-categoriesItemImage" />
      <div className="home-categoriesItemTitleWrapper">
        <h3 className="home-categoriesItemTitle">{category.name}</h3>
      </div>
      <span className="home-categoriesItemDescription">
        <p>{category.seo_description}</p>
      </span>
    </li>;
    });

    

    return (
      <section className="section-container home-categories">


        <h3 className="section-title home-categoriesTitle home-searchTitle">Explore across categories</h3>

        <div className="section-body home-categoriesContainer">
          <p className="home-categoriesDescription">Discover thousands of valuable and vetted organizations, programs, and services exclusively for women</p>
          <ul className="home-categoriesList">
              {categoryList}
          </ul>
          
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, 
  { 
    loadHomePageCategories,
    push 
  }
  )(HomeCategories);



// WEBPACK FOOTER //
// ./src/components/HomeCategories.jsx